import { render, staticRenderFns } from "./SalesAssessmentComponent.vue?vue&type=template&id=716be678&scoped=true"
import script from "./SalesAssessmentComponent.vue?vue&type=script&lang=js"
export * from "./SalesAssessmentComponent.vue?vue&type=script&lang=js"
import style0 from "./SalesAssessmentComponent.vue?vue&type=style&index=0&id=716be678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716be678",
  null
  
)

export default component.exports